import { memo, useEffect } from 'react'
import { usePostcodeDistrictsDialog } from '../../providers/PostcodeDistrictsDialogProvider'

const MapPage = () => {
  const { openPostcodeDistrictsDialog, closePostcodeDistrictsDialog } = usePostcodeDistrictsDialog()
  useEffect(() => {
    openPostcodeDistrictsDialog()
    return () => {
      closePostcodeDistrictsDialog()
    }
  })
  return null
}

export default memo(MapPage)
